import { jsx, jsxs } from "react/jsx-runtime";
import { memo } from "react";
import {
  Path,
  Svg,
  Circle as _Circle
} from "react-native-svg";
import { themed } from "../themed";
const Icon = (props) => {
  const { color = "black", size = 24, ...otherProps } = props;
  return /* @__PURE__ */ jsxs(
    Svg,
    {
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: `${color}`,
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      ...otherProps,
      children: [
        /* @__PURE__ */ jsx(Path, { d: "M20,2l-4.5,4.5", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M19,3l1,1", stroke: `${color}` }),
        /* @__PURE__ */ jsx(_Circle, { cx: "14", cy: "8", r: "2", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M4,19.5C4,18.1,5.1,17,6.5,17H20", stroke: `${color}` }),
        /* @__PURE__ */ jsx(
          Path,
          {
            d: "M20,8v14H6.5C5.1,22,4,20.9,4,19.5v-15C4,3.1,5.1,2,6.5,2H14",
            stroke: `${color}`
          }
        )
      ]
    }
  );
};
Icon.displayName = "BookKey";
const BookKey = memo(themed(Icon));
export {
  BookKey
};
//# sourceMappingURL=book-key.js.map
